import { render, staticRenderFns } from "./my-base-info.vue?vue&type=template&id=50188f24&scoped=true&"
import script from "./my-base-info.vue?vue&type=script&lang=js&"
export * from "./my-base-info.vue?vue&type=script&lang=js&"
import style0 from "./my-base-info.vue?vue&type=style&index=0&id=50188f24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50188f24",
  null
  
)

export default component.exports